import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Button } from '@amzn/storm-ui';
import { getFeedbackTriggerProps } from '@amzn/intro-widgets-api';
import { useChromeConfigContext } from 'src/providers/ChromeConfigContextProvider';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';
import { getTaktAttributes, logWithTakt } from 'src/commons/utils/logWithTakt';
import { FeedbackTriggerPublisher } from 'src/commons/utils/metrics';
import { useFooterBundle } from 'src/providers/PantherLocalizationProvider/PantherLocalizationProvider';
import { chromeComponents } from 'src/constants';

const StyledButton = styled(Button)`
  position: fixed;
  bottom: 6rem;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-bottom: 0;

  /*! @noflip */
  left: auto;
  /*! @noflip */
  right: 0;
  transform: rotate(270deg) translateX(100%);
  /*! @noflip */
  transform-origin: right bottom;

  [dir='rtl'] & {
    /*! @noflip */
    left: 0;
    /*! @noflip */
    right: auto;
    transform: rotate(90deg) translateX(-100%);
    /*! @noflip */
    transform-origin: left bottom;
  }
`;

const componentId = 'AD_CONSOLE_PAGE_LEVEL_FEEDBACK';
const cssfElementId = 'FITCSSF';

const FeedbackTrigger: React.VFC = () => {
  const bundle = useFooterBundle();
  const chromeConfig = useChromeConfigContext();
  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  const cssfElement = document.getElementById(cssfElementId);
  const app = internalChromeConfig?.applicationName;
  const page = chromeConfig?.pageId || 'Unknown';

  useEffect(() => {
    if (cssfElement) {
      logWithTakt(
        `cssf-feedback-trigger-loaded-${app}-${page}-${componentId}`,
        {},
      );
      FeedbackTriggerPublisher.publishCounterMonitor(
        `rendered-${app}-${page}-${componentId}`,
        1,
      );
    }
  }, []);

  if (!cssfElement) {
    return null;
  }

  return (
    <StyledButton
      data-testid="feedback-trigger"
      {...getFeedbackTriggerProps({
        application: app ?? '',
        page: page,
        component: componentId,
      })}
      {...getTaktAttributes('feedback-trigger', chromeComponents.FOOTER)}
    >
      {bundle.getMessage('footer-feedback')}
    </StyledButton>
  );
};

export default FeedbackTrigger;
